// src/embed.jsx
import React, { useEffect } from "react";
import "./motomate-widget"; // defines <motomate-chat>

export default function Embed() {
  const p = new URLSearchParams(window.location.search);

  const vehicleReg = p.get("vehicleReg") || "AB12 CDE";
  const reserved = (p.get("reserved") || "false").toLowerCase() === "true";
  const description = p.get("description") || "Low mileage. Full history.";
  const embedded = p.get("embedded") === "1";

  useEffect(() => {
    const el = document.querySelector("motomate-chat");
    if (!el) return;

    // pass config
    if (el.setConfig) el.setConfig({ vehicleReg, reserved, description });

    // if we’re in the loader iframe, force inline/open mode
    if (embedded) {
      // Prefer an official API/attribute on your component if you have one:
      //  - el.inline = true
      //  - el.setAttribute('inline','')
      //  - el.openChat?.()
      // Fallbacks below if you don’t have APIs yet:

      // Hint your component via attributes:
      el.setAttribute("data-inline", "1");
      el.setAttribute("data-open", "1");
    }
  }, [vehicleReg, reserved, description, embedded]);

  return (
    <div style={{ height: "100vh", margin: 0 }}>
      <motomate-chat inline style={{ display: "block", height: "100%" }} />
    </div>
  );
}
